var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableCloseEventListener, CloseEventListener, OpenEventListener } from '@philips-internal/oswald-ui-core/lib/component/types';
class CustomContextMenuAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        this.onBeforeClose = new AbortableCloseEventListener();
        this.onClose = new CloseEventListener();
        this.onOpen = new OpenEventListener();
    }
    close() {
        if (!this.isOpen()) {
            return;
        }
        let close = true;
        const abort = () => { close = false; };
        this.onBeforeClose.fire({ abort });
        if (close) {
            this.setState({ open: false });
            this.onClose.fire();
        }
    }
    open() {
        if (this.isOpen()) {
            return;
        }
        this.setState({ open: true });
        this.onOpen.fire();
    }
    getPlacement() {
        return this.state.placement;
    }
    setPlacement(placement) {
        this.setState({ placement });
    }
    isOpen() {
        return this.state.open;
    }
    setOpen(open) {
        this.setState({ open });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CustomContextMenuAPI.prototype, "onBeforeClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CustomContextMenuAPI.prototype, "onClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CustomContextMenuAPI.prototype, "onOpen", void 0);
export default CustomContextMenuAPI;
//# sourceMappingURL=custom-context-menu-api.js.map